import request from 'superagent';
import tree from '../state';
import config from '../config';

export function clearCache(argToken) {
	return request.get(`${config.apiBase}/api/cache-clear?token=${argToken}`)
	.set('authorization', tree.get('token'))
    .then(res => JSON.parse(res.text));
}

export function cleanCache() {
	return request.get(`${config.apiBase}/api/clear-cache`).then(res => JSON.parse(res.text));
}




// WEBPACK FOOTER //
// ./src/services/cacheService.js